<template>
  <div class="dashboard-card">
    <v-card class="actual-card">
      <v-card-title>Summary of Policies</v-card-title>
      <v-card-text>
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
            <tr>
              <th>Policy</th>
              <th>Effective Date</th>
              <th>Expiration Date</th>
            </tr>
            </thead>
            <tbody>
            <tr v-if="!list || list.length === 0">
              <td colspan="3"></td>
            </tr>
            <tr v-for="(policy, i) in list" :key="`policy-${i}`">
              <td>
                <router-link :to="buildPolicyRoute(policy)">
                  {{ nameOrType(policy) }}
                </router-link>
              </td>
              <td>{{ formatTimestampToCommonDate(policy.effectiveDate) }}</td>
              <td>{{ formatTimestampToCommonDate(policy.expirationDate) }}</td>
            </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import * as policyApi from '@/components/policy/policy-api'
import * as textUtil from '@/components/shared/text-util'

export default {
  data: () => {
    return {
      loading: true,
      list: [],
    }
  },
  mounted() {
    this.getPolicies()
  },
  methods: {
    buildPolicyRoute(policy) {
      return policyApi.buildPolicyDetailRoute(this.accountCode, policy)
    },
    async getPolicies() {
      try {
        const response = await policyApi.getPolicies(this.accountCode)
        if (response.data) {
          this.list = response.data
        }
      } catch (ex) {
        console.error(ex)
        this.$error('Failed to retrieve policies')
      }
    },
    formatTimestampToDate(timestampString, useShortYear) {
      return textUtil.formatTimestampToDate(timestampString, useShortYear)
    },
    formatTimestampToCommonDate(timestampString) {
      return textUtil.formatTimestampToCommon(timestampString)
    },
    nameOrType(policy) {
      const carrier = policy?.carrier
      const name = policy?.name
      const policyType = policy?.policyType
      const nameOrType = name || policyType
      if (carrier) {
        return carrier + " " + nameOrType
      }
      return nameOrType
    },
  },
  computed: {
    accountCode() {
      return this.$route.params.accountId
    },
  },
}
</script>
<style scoped lang="scss">
@import '~@/scss/variables';
.dashboard-card {
  height: 100%;
}
.actual-card {
  &.v-card {
    height: 100%;
    min-height: 318px;
  }
  .v-card__text {
    padding-bottom: 3rem;

    max-height: 13rem;
    overflow-y: auto;
  }
  .v-card__actions {
    background-color: white;
    position: absolute;
    bottom: 0;
    width: 100%;
  }
}
</style>